import { Component, Injector, Input, OnInit } from '@angular/core';

import { CustomElement, EntityService, ModalService } from '@kaiser-software/chassis-core';

import { TaxService } from '../../services/tax.service';

@Component({
    selector: 'donna-tax-settings-plugin',
    templateUrl: './tax-settings.plugin.html',
    styleUrls: [ './tax-settings.plugin.scss' ]
})
export class TaxSettingsPlugin extends CustomElement implements OnInit {

    @Input() public form;

    protected table;

    protected entityService: EntityService;

    protected taxService: TaxService;

    protected modalService: ModalService;

    protected datatableInstance;

    constructor(protected injector: Injector) {
        super();

        this.entityService = this.injector.get(EntityService);
        this.taxService    = this.injector.get(TaxService);
        this.modalService  = this.injector.get(ModalService);
    }

    ngOnInit() {
        if (!this.val) {
            this.val = {};
        }

        this.table = {
            callbacks: {},
            columns: [ {
                name: 'code',
                data: 'code',
                title: 'Code',
                visible: true,
                filter: {
                    filter_type: 'text',
                    filter_delay: 1000,
                }
            }, {
                name: 'name',
                data: 'name',
                title: 'Name',
                visible: true,
                filter: {
                    filter_type: 'text',
                    filter_delay: 1000,
                }
            }, {
                name: 'rate',
                data: 'rate',
                title: 'Rate',
                visible: true,
            }, {
                name: 'default',
                data: 'default',
                title: 'Default',
                visible: true,
            } ],
        };

        this.table.service = this.taxService;

        this.table.ajax = this.table.service.all(true, {
            datatable: true,
        });

        // this.table.callbacks['click'] = (data) => {
        //     const model = TaxModel.make(data, this.taxService);
        //
        //     const self = this;
        //
        //     this.modalService.create(CoreBootstrapModule, TaxEditModal, {}, {
        //         model: model,
        //         onSave() {
        //             self.refreshDatatable();
        //         },
        //     });
        // };
    }

    protected setDatatableInstance(event) {
        this.datatableInstance = event;
    }

    protected refreshDatatable() {
        if (this.datatableInstance) {
            this.datatableInstance.refresh();
        }
    }

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/tax/plugins/tax-settings/tax-settings.plugin.ts